import { RecipeVariantProps, sva } from "styled-system/css";

export const simpleFlagRecipe = sva({
  slots: ["box", "text"],
  base: {
    box: {
      borderLeftWidth: "6px",
      borderStyle: "solid",
      borderColor: "border.accent.purple",
      borderRadius: "full",
    },
    text: {
      color: "text.accent.purple.dark",
    },
  },
  variants: {
    visual: {
      primary: {
        box: {
          borderColor: "border.dark",
        },
        text: {
          color: "text.dark",
        },
      },
      highlight: {
        box: {
          borderColor: "border.highlight",
        },
        text: {
          color: "text.highlight.dark",
        },
      },
      success: {
        box: {
          borderColor: "border.success",
        },
        text: {
          color: "text.success.dark",
        },
      },
      warning: {
        box: {
          borderColor: "border.warning",
        },
        text: {
          color: "text.warning.dark",
        },
      },
      destructive: {
        box: {
          borderColor: "border.error",
        },
        text: {
          color: "text.error.dark",
        },
      },
      "accent.blue": {
        box: {
          borderColor: "border.accent.blue",
        },
        text: {
          color: "text.accent.blue.dark",
        },
      },
      "accent.purple": {
        box: {
          borderColor: "border.accent.purple",
        },
        text: {
          color: "text.accent.purple.dark",
        },
      },
      "accent.magenta": {
        box: {
          borderColor: "border.accent.magenta",
        },
        text: {
          color: "text.accent.magenta.dark",
        },
      },
    },
  },
  defaultVariants: {
    visual: "accent.purple",
  },
});

export type StatusIndicatorVariants = RecipeVariantProps<
  typeof simpleFlagRecipe
>;
